import { request } from "@/api/client";

export type InviteValidateResponse = {
  valid: boolean;
  email?: string;
  role?: string;
  organization_id?: string;
  expires_at?: string;
  accepted_at?: string;
};

export type InviteClaimPayload = {
  token: string;
  first_name: string;
  last_name: string;
  password: string;
};

export type InviteClaimResponse = {
  access_token: string;
  token_type: string;
  user_profile: {
    id: string;
    email: string;
    name: string;
  };
  organization: {
    id: string;
    name: string;
  };
  onboarding_status: Record<string, unknown>;
};

export type InviteCreateResponse = {
  token: string;
  invite_url: string;
  expires_at: string;
};

export type InviteSummary = {
  id: string;
  email: string;
  role: string;
  organization_id?: string;
  invited_by_user_id?: string;
  expires_at: string;
  accepted_at?: string;
  created_at: string;
  valid: boolean;
  token?: string;
  invite_url?: string;
};

export function validateInvite(token: string) {
  return request<InviteValidateResponse>(`/invites/validate?token=${encodeURIComponent(token)}`);
}

export function claimInvite(payload: InviteClaimPayload) {
  return request<InviteClaimResponse>("/invites/claim", {
    method: "POST",
    body: payload,
  });
}

export function listInvites() {
  return request<InviteSummary[]>("/invites/list");
}

export function resendInvite(inviteId: string) {
  return request<{ invite_url: string }>("/invites/resend", {
    method: "POST",
    body: { invite_id: inviteId },
  });
}

export function createInvite(payload: {
  email: string;
  role?: string;
  organization_id?: string;
  artist_ids?: string[];
  can_view_financials?: boolean;
}) {
  return request<InviteCreateResponse>("/invites/create", {
    method: "POST",
    body: payload,
  });
}
